import { relativeRange, shiftDateInput, todayAsDateInput } from '@/lib/format'

/**
 * Tarih aralığı seçicisinin hazır aralıkları (her ekranda aynı liste). Uçlar dahil,
 * `YYYY-MM-DD` takvim günü; `all` = tarih filtresi yok.
 */
export const DATE_PRESETS = [
  'today',
  'yesterday',
  'last7',
  'last30',
  'last90',
  'thisMonth',
  'lastMonth',
  'all',
] as const
export type DatePreset = (typeof DATE_PRESETS)[number]

/** Göreli (`-7d`) dışında rapor meta'sının `default`'unda kullanılabilen adlar. */
export const NAMED_DEFAULT_RANGES = ['thisMonth'] as const

export interface DayRange {
  from: string | undefined
  to: string | undefined
}

const firstOfMonth = (day: string) => `${day.slice(0, 8)}01`

export function presetRange(preset: DatePreset, today = todayAsDateInput()): DayRange {
  switch (preset) {
    case 'all':
      return { from: undefined, to: undefined }
    case 'today':
      return { from: today, to: today }
    case 'yesterday': {
      const day = shiftDateInput(today, -1)
      return { from: day, to: day }
    }
    case 'last7':
      return { from: shiftDateInput(today, -6), to: today }
    case 'last30':
      return { from: shiftDateInput(today, -29), to: today }
    case 'last90':
      return { from: shiftDateInput(today, -89), to: today }
    case 'thisMonth':
      return { from: firstOfMonth(today), to: today }
    case 'lastMonth': {
      const lastDay = shiftDateInput(firstOfMonth(today), -1)
      return { from: firstOfMonth(lastDay), to: lastDay }
    }
  }
}

/** Rapor meta'sındaki varsayılan aralık: ad (`thisMonth`) ya da göreli (`-1d` = bugün). */
export function resolveDefaultRange(token: string, today = todayAsDateInput()): DayRange {
  return (NAMED_DEFAULT_RANGES as readonly string[]).includes(token)
    ? presetRange(token as DatePreset, today)
    : relativeRange(token, today)
}

/** Aralık bir hazır aralığa denk geliyorsa onun adı (seçici etiketi için). */
export function matchPreset(
  from: string | undefined,
  to: string | undefined,
  today = todayAsDateInput(),
): DatePreset | undefined {
  return DATE_PRESETS.find((preset) => {
    const range = presetRange(preset, today)
    return range.from === from && range.to === to
  })
}
